/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

import _react from 'react';

const SegmentedControlContext = /*#__PURE__*/ (0, _react.createContext)(null);

export default SegmentedControlContext;
